import type {
  EHumanReviewRequestProblem,
  EHumanReviewResolution,
  THumanReviewTab,
} from './human-review-requests.type'

export const getAvailableProblems = (tab: THumanReviewTab) =>
  Object.keys(tab.problemCounts) as EHumanReviewRequestProblem[]

export const getAvailableResolutions = (tab: THumanReviewTab) =>
  Object.keys(tab.resolutionCounts) as EHumanReviewResolution[]

type TFilterSelectionInput = {
  tab: THumanReviewTab
  problems: EHumanReviewRequestProblem[] | null
  resolutions: EHumanReviewResolution[] | null
  medEventIds: number[] | null
  allMedEventIds: number[]
}

// A filter absent from the URL is `null` and falls back to its default selection.
// A filter explicitly emptied is `[]`, which is truthy: `||` only falls back on `null`.
export const resolveFilterSelection = ({
  tab,
  problems,
  resolutions,
  medEventIds,
  allMedEventIds,
}: TFilterSelectionInput) => {
  const availableProblems = getAvailableProblems(tab)
  const availableResolutions = getAvailableResolutions(tab)

  return {
    selectedProblems: problems?.filter((problem) => availableProblems.includes(problem)) || availableProblems,
    selectedResolutions: resolutions?.filter((resolution) => availableResolutions.includes(resolution)) || [],
    selectedMedEventIds:
      medEventIds?.filter((medEventId) => allMedEventIds.includes(medEventId)) || allMedEventIds,
  }
}
